import { Selector, State } from "@ngxs/store";
import { BioSealStateModel } from "../../model/bioseal.model";
import {
  setBiometrics,
  setBioSealFormat,
  setBioSealPersonalContent,
  setBioSealDocumentContent,
  getBioSeal,
  setDefaultBioseal,
  setContentDefault,
  setBioSealPractitionerContent,
  setBioSealTestContent,
  setDefaultResult,
  setPersonalFormSubmition,
  setDocumentFormSubmition,
  setPractitionerFormSubmition,
  setTestFormSubmition,
  setBioSealEventContent,
  setEventFormSubmition,
} from "../actions/bioseal.action";
import { Action, StateContext } from "@ngxs/store";
import { BioSealService } from "../../services/async/connectors/bioseal.service";
import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { EMPTY } from "rxjs";
import { DateFormatUtils } from "../../utils/date-format.utils";
@State<BioSealStateModel>({
  name: "bioseal",
  defaults: {
    biosealState: null,
    isPersonalFormSubmitted: false,
    isDocumentFormSubmitted: false,
    isPractitionerFormSubmitted: false,
    isEventFormSubmitted: false,
    isTestFormSubmitted: false,
    isPersonalDataLoaded: false,
    isDocumentDataLoaded: false,
    isPractitionerDataLoaded: false,
    isTestDataLoaded: false,
    isEventDataLoaded: false,
    bioseal: null,
    qrCode: null,
    datamatrix: null,
    biosealLoaded: false,
    biosealLoading: true,
    biosealError: false,
    timeOut: false,
  },
})
@Injectable()
export class BioSealState {
  constructor(private biosealService: BioSealService) { }

  @Selector()
  static getQRcodeResult(state: BioSealStateModel) {
    return state.qrCode;
  }
  @Selector()
  static getDatamatrixResult(state: BioSealStateModel) {
    return state.datamatrix;
  }
  @Selector()
  static getBioSealData(state: BioSealStateModel) {
    return state;
  }
  @Selector()
  static getBioSealFormat(state: BioSealStateModel) {
    return state.biosealState.bioSealFormat;
  }
  @Selector()
  static getBiometricsType(state: BioSealStateModel) {
    return state.biosealState.biometrics;
  }
  @Selector()
  static getBioSeal(state: BioSealStateModel) {
    return state.bioseal;
  }
  @Selector()
  static isBioSealReady(state: BioSealStateModel) {
    return state.biosealLoaded;
  }
  @Selector()
  static isBioSealLoading(state: BioSealStateModel) {
    return state.biosealLoading;
  }
  @Selector()
  static isBioSealError(state: BioSealStateModel) {
    return state.biosealError;
  }
  @Selector()
  static isTimeOutBioSeal(state: BioSealStateModel) {
    return state.timeOut;
  }

  @Selector()
  static getFirstName(state: BioSealStateModel) {
    return state.biosealState.personalContent.firstName;
  }
  @Selector()
  static getLastName(state: BioSealStateModel) {
    return state.biosealState.personalContent.lastName;
  }
  @Selector()
  static getFunction(state: BioSealStateModel) {
    return state.biosealState.personalContent.function;
  }
  @Selector()
  static getEventName(state: BioSealStateModel) {
    return state.biosealState.eventContent.eventName.substr(1);
  }
  @Selector()
  static getEventAddress(state: BioSealStateModel) {
    return state.biosealState.eventContent.eventAddress;
  }
  @Selector()
  static getEventDate(state: BioSealStateModel) {
    return DateFormatUtils.formatDateToDisplay(state.biosealState.eventContent.eventDate);
  }
  @Selector()
  static getEventTime(state: BioSealStateModel) {
    return state.biosealState.eventContent.eventTime;
  }
  @Selector()
  static isParkingAuthorized(state: BioSealStateModel) {
    return state.biosealState.eventContent.parkingAcc;
  }
  @Selector()
  static isGrandstandAuthorized(state: BioSealStateModel) {
    return state.biosealState.eventContent.grandstandAcc;
  }
  @Selector()
  static isPressAuthorized(state: BioSealStateModel) {
    return state.biosealState.eventContent.pressAcc;
  }
  @Selector()
  static isVIPAuthorized(state: BioSealStateModel) {
    return state.biosealState.eventContent.vipAcc;
  }
  @Selector()
  static areCloakroomsAuthorized(state: BioSealStateModel) {
    return state.biosealState.eventContent.cloakroomAcc;
  }
  @Selector()
  static isRestaurantAuthorized(state: BioSealStateModel) {
    return state.biosealState.eventContent.restaurantAcc;
  }


  //Forms submition
  @Selector()
  static isTestFormSubmitted(state: BioSealStateModel) {
    return state.isTestFormSubmitted;
  }
  @Selector()
  static isEventFormSubmitted(state: BioSealStateModel) {
    return state.isEventFormSubmitted;
  }
  @Selector()
  static isPersonalFormSubmitted(state: BioSealStateModel) {
    return state.isPersonalFormSubmitted;
  }
  @Selector()
  static isDocumentFormSubmitted(state: BioSealStateModel) {
    return state.isDocumentFormSubmitted;
  }
  @Selector()
  static isPractitionerFormSubmitted(state: BioSealStateModel) {
    return state.isPractitionerFormSubmitted;
  }

  //Forms data load
  @Selector()
  static isTestDataLoaded(state: BioSealStateModel) {
    return state.isTestDataLoaded;
  }
  @Selector()
  static isEventDataLoaded(state: BioSealStateModel) {
    return state.isEventDataLoaded;
  }
  @Selector()
  static isPersonalDataLoaded(state: BioSealStateModel) {
    return state.isPersonalDataLoaded;
  }
  @Selector()
  static isDocumentDataLoaded(state: BioSealStateModel) {
    return state.isDocumentDataLoaded;
  }
  @Selector()
  static isPractitionerDataLoaded(state: BioSealStateModel) {
    return state.isPractitionerDataLoaded;
  }

  @Action(setDefaultBioseal)
  setDefault({ getState, patchState }: StateContext<BioSealStateModel>) {
    const state = getState();
    patchState({
      biosealState: {
        bioSealFormat: "BigSquare",
        biometrics: "both",
        personalContent: null,
        documentContent: null,
        practitionerContent: null,
        testContent: null,
        eventContent: null
      },
      isPersonalDataLoaded: false,
      isDocumentDataLoaded: false,
      isPractitionerDataLoaded: false,
      isPersonalFormSubmitted: false,
      isDocumentFormSubmitted: false,
      isPractitionerFormSubmitted: false,
      isTestFormSubmitted: false,
      isEventFormSubmitted: false,
      isTestDataLoaded: false,
      isEventDataLoaded: false,
      bioseal: null,
      qrCode: null,
      datamatrix: null,
      biosealLoaded: false,
      biosealLoading: true,
      biosealError: false,
      timeOut: false,
    });
  }
  @Action(setDefaultResult)
  setDefaultResult({ getState, patchState }: StateContext<BioSealStateModel>) {
    const state = getState();
    patchState({
      ...state,
      biosealLoaded: false,
      biosealLoading: true,
      biosealError: false,
      timeOut: false
    });
  }
  @Action(setBioSealFormat)
  setBioSealFormat(
    { getState, patchState }: StateContext<BioSealStateModel>,
    { payload }: setBioSealFormat
  ) {
    const state = getState();
    patchState({
      biosealState: { ...state.biosealState, bioSealFormat: payload }
    });
  }

  @Action(setBiometrics)
  setBiometrics(
    { getState, patchState }: StateContext<BioSealStateModel>,
    { payload }: setBiometrics
  ) {
    const state = getState();
    patchState({
      biosealState: { ...state.biosealState, biometrics: payload }
    });
  }

  @Action(setPersonalFormSubmition)
  setPersonalFormSubmition({ getState, patchState }: StateContext<BioSealStateModel>) {
    const state = getState();
    patchState({
      ...state,
      isPersonalFormSubmitted: true
    });
  }

  @Action(setDocumentFormSubmition)
  setDocumentFormSubmition({ getState, patchState }: StateContext<BioSealStateModel>) {
    const state = getState();
    patchState({
      ...state,
      isDocumentFormSubmitted: true
    });
  }

  @Action(setPractitionerFormSubmition)
  setPractitionerFormSubmition({ getState, patchState }: StateContext<BioSealStateModel>) {
    const state = getState();
    patchState({
      ...state,
      isPractitionerFormSubmitted: true
    });
  }

  @Action(setTestFormSubmition)
  setTestFormSubmition({ getState, patchState }: StateContext<BioSealStateModel>) {
    const state = getState();
    patchState({
      ...state,
      isTestFormSubmitted: true
    });
  }

  @Action(setEventFormSubmition)
  setEventFormSubmition({ getState, patchState }: StateContext<BioSealStateModel>) {
    const state = getState();
    patchState({
      ...state,
      isEventFormSubmitted: true
    });
  }

  @Action(setBioSealPersonalContent)
  setPersonalContent(
    { getState, patchState }: StateContext<BioSealStateModel>,
    { payload }: setBioSealPersonalContent
  ) {
    const state = getState();
    patchState({
      biosealState: {
        ...state.biosealState,
        personalContent: payload.data,
      },
      isPersonalDataLoaded: payload.validation,
    });
  }
  @Action(setBioSealDocumentContent)
  setDocumentContent(
    { getState, patchState }: StateContext<BioSealStateModel>,
    { payload }: setBioSealDocumentContent
  ) {
    const state = getState();
    patchState({
      biosealState: {
        ...state.biosealState,
        documentContent: payload.data,
      },
      isDocumentDataLoaded: payload.validation,
    });
  }

  @Action(setBioSealPractitionerContent)
  setPractitionerContent(
    { getState, patchState }: StateContext<BioSealStateModel>,
    { payload }: setBioSealPractitionerContent
  ) {
    const state = getState();
    patchState({
      biosealState: {
        ...state.biosealState,
        practitionerContent: payload.data,
      },
      isPractitionerDataLoaded: payload.validation,
    });
  }

  @Action(setBioSealTestContent)
  setTestContent(
    { getState, patchState }: StateContext<BioSealStateModel>,
    { payload }: setBioSealTestContent
  ) {
    const state = getState();
    patchState({
      biosealState: {
        ...state.biosealState,
        testContent: payload.data,
      },
      isTestDataLoaded: payload.validation,
    });
  }

  @Action(setBioSealEventContent)
  setEventContent(
    { getState, patchState }: StateContext<BioSealStateModel>,
    { payload }: setBioSealEventContent
  ) {
    const state = getState();
    patchState({
      biosealState: {
        ...state.biosealState,
        eventContent: payload.data,
      },
      isEventDataLoaded: payload.validation
    });
  }

  @Action(getBioSeal)
  getBioSealImage(
    { getState, patchState }: StateContext<BioSealStateModel>,
    { payload }: getBioSeal
  ) {
    const state = getState();

    return this.biosealService
      .getBioSeal(
        state.biosealState.bioSealFormat,
        state.biosealState.personalContent,
        state.biosealState.documentContent,
        state.biosealState.practitionerContent,
        state.biosealState.testContent,
        state.biosealState.eventContent,
        payload.token,
        payload.face,
        payload.url,
        state.biosealState.biometrics,
        payload.barcode,
        payload.usecase
      )
      .pipe(
        map((res) => {
          if (res === null || res == "") {
            patchState({
              bioseal: null,
              biosealLoaded: false,
              biosealLoading: false,
              biosealError: true,
              timeOut: false,
            });
          } else {
            patchState({
              bioseal: res,
              biosealLoaded: true,
              biosealLoading: false,
              biosealError: false,
              timeOut: false,
            });
          }
        }),
        catchError((error) => {
          if (error.status === 0 || error.status === 401) {
            patchState({
              ...state.bioseal,
              bioseal: null,
              biosealLoaded: false,
              biosealLoading: true,

              timeOut: true,
            });
            return EMPTY;
          } else {
            patchState({
              ...state.bioseal,
              bioseal: null,
              biosealLoaded: false,
              biosealLoading: true,
              timeOut: false,
              biosealError: true,
            });
          }
        })
      );
  }
  @Action(setContentDefault)
  setContentDefault({ getState, patchState }: StateContext<BioSealStateModel>) {
    const state = getState();
    patchState({
      biosealState: {
        ...state.biosealState,
        documentContent: null,
        personalContent: null,
      },
      isDocumentDataLoaded: false,
      isPersonalDataLoaded: false,
    });
  }
}
